// extracted by mini-css-extract-plugin
module.exports = {"DefinitionList":"DefinitionList__DefinitionList__3ibOy","label":"DefinitionList__label__WaUon","value":"DefinitionList__value__1yCxi"};